import { writable } from 'svelte/store';
export const createAlertStore = () => {
    const alertState = [];
    const alertStore = writable(alertState);
    const show = (message, buttonLabel, buttonAction) => {
        alertStore.update((state) => {
            state.push({ message, buttonLabel, buttonAction });
            return state;
        });
    };
    const hide = (index) => {
        alertStore.update((state) => {
            state.splice(index, 1);
            return state;
        });
    };
    return {
        subscribe: alertStore.subscribe,
        show,
        hide,
    };
};
